var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABGlBMVEX////AwAD87wD+8AD+ 7wD+8AD+8AD97gDv7wD88AD+8AD+8AD+8AD97wD97wD+7wD+8AD+8AD98ACAgAD98AD+8AD+8ADx 4wD97gD+8AD+7wDNzQD88AD+8AD97wD46gD+8AD+8AD+8AD+8AD77wD+8AD68AD87wD+8ADy5QD+ 8AD+7wD+8AD+7wD97wD+8AD+7wD97wD67wD+8AD56wD06QD+7wD87gD97wD+7wABAQD+8AD+8ADx 4gD+8AD97gDz5wD+8AD46gD+8AD+8ACrqwD+8AD77wD06AD+8AD87gD+7wD+8AD97gD57AD87QD+ 8AD+8AD87wD68AD+8AD+8AD97wD87QD+8AD87gD87gD+8AD/8AD///+UVXaJAAAAXHRSTlMABE2X vMGlZw9C2PWxf3ia3/B2AmX6kBJW6a0FQPlcI+OT1489/DFP9hOwnJiqWua+fC3GJRerR23dAZHA EfFZFe0ktdAD5T4Wt0mOs1UoRNH4SzKg61tG90hKulAqD9UAAAABYktHRACIBR1IAAAACXBIWXMA AEzlAABM5QF1zvCVAAAAB3RJTUUH5goGBC0NOoCbzAAAAMpJREFUGNNtjtUSwjAQRVPcpbhrobg7 FC3uLvn/76BNKWSAfTl3zk42FwBuCIlUJlcoVQAbtUar0xuMJjNpeTurze7gaXG63J6X8/r84joQ DAmBCEc+h6JUDDFOJ7DzyRRCOoP/mc0h5Au4LELUq0TisgwrPKppXNZ8BI96o4nJVhuhw3Q/rse8 Ohv6A9F5hiNWSKxuPBHSdAbpubhfUMvVuryJMFsa7vbis8PxBCGdP7OXK2YBcPRQlxtn7+B7OHv1 /rOyHwnUD8kTr/AajDT+Vy0AAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMTAtMDZUMDQ6NDU6MTMr MDA6MDB/MTWDAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTEwLTA2VDA0OjQ1OjEzKzAwOjAwDmyN PwAAACh0RVh0ZGF0ZTp0aW1lc3RhbXAAMjAyMi0xMC0wNlQwNDo0NToxMyswMDowMFl5rOAAAAAA SUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch20);
export default __webpack_public_path__ + "static/media/search-20.6a6d8087480ff6ab3c37ae0f0d473d6d.svg";
export { ForwardRef as ReactComponent };